import { render, staticRenderFns } from "./OpportunityPreview.vue?vue&type=template&id=b70bb7b8&"
import script from "./OpportunityPreview.vue?vue&type=script&lang=js&"
export * from "./OpportunityPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports